<template>
    <button @click="$emit('click')" :disabled="disabled" :type="type"

            class="text-center items-center px-4 py-2 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest focus:outline-none focus:shadow-outline-gray transition ease-in-out duration-150"
            :class="[{'bg-gray-600 hover:bg-gray-600 cursor-not-allowed': disabled},{'hover:bg-gray-700 bg-gray-800 active:bg-gray-900 focus:border-gray-900':!disabled}]"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'submit',
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>
